import { AfterViewInit, ChangeDetectorRef, Component, inject } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { Admin } from '../../services/admin';
import { Auth } from '../../services/auth';
import { CustomValidators } from '../../validators/customValidators';
import { Country } from 'country-state-city';

import { first } from 'rxjs';
import { Help } from '../../pages/common-features/help/help';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.html',
  styleUrl: './login.less',
})
export class Login implements AfterViewInit {
  private cdRef = inject(ChangeDetectorRef)
  loginForm!: FormGroup;
  submitted = false;
  hide: boolean = true;
  loading: boolean = false;
  message: any;
  showPassword: boolean = false;
  isPhoneNumber: boolean = false;
  showError: boolean = false;
  ssoResponse: any;
  countries = Country.getAllCountries();
  countryCode: string = 'us';
  selectedCountry = this.countries.find(
    c => c.isoCode === 'US'
  );
  countryPhoneCode: string = '+1';
  constructor(
    private formBuilder: FormBuilder,
    private adminService: Admin,
    private authService: Auth,
    private router: Router,
    private dialog: MatDialog
  ) {
    // console.log("login ");
  }
  ngAfterViewInit(): void {
    // (window as any).handleCredentialResponse = (response: any) => {
    //   console.log('Encoded JWT ID token: ' + response);
    //   const idToken = response.credential;
    //   const formData = {
    //     token: idToken,
    //     source: 'GOOGLE'
    //   }
    //   this.adminService.ssoLogin(formData)
    //     .subscribe({
    //       next: (data: any) => {
    //         console.log(data);
    //         this.ssoResponse = data;
    //         if (this.ssoResponse.registered == false) {
    //           this.router.navigate(['/registration'])
    //         } else {
    //           this.router.navigate(['/home'], { replaceUrl: true })
    //         }
    //       }
    //     })
    //   fetch('http://localhost:8080/api/auth/google', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ token: idToken })
    //   })
    //     .then(res => {
    //       if (!res.ok) {
    //         throw new Error('Network response was not ok');
    //       }
    //       return res.json();
    //     })
    //     .then(data => {
    //       const token = data?.token;
    //       const formData = {
    //         token: idToken,
    //         source: 'GOOGLE'
    //       }
    //       this.adminService.ssoLogin(formData)
    //         .subscribe({
    //           next: (data: any) => {
    //             console.log(data);
    //           }
    //         })
    //     })
    //     .catch(error => {
    //       console.error('There was a problem with the fetch operation:', error);
    //     })
    // }
    // (window as any).google?.accounts.id.renderButton(
    //   document.getElementById('google-signin-button'),
    //   { theme: 'outline', size: 'large' }
    // );
  }

  ngOnInit(): void {

    this.loginForm = this.formBuilder.group({
      // username:['',[Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      phoneNumber: [''],
      countryCode: ['1'],
      username: [
        '',
        [Validators.required, Validators.email],
      ],
      password: ['', Validators.required],
      rememberMe: [false]
    });
    this.clearServerError();
    // (window as any).handleCredentialResponse = (response: any) => {
    //   console.log('Encoded JWT ID token: ' + response);
    //   const idToken = response.credential;
    //   const formData = {
    //     token: idToken,
    //     source: 'GOOGLE'
    //   }
    //   this.adminService.ssoLogin(formData)
    //     .subscribe({
    //       next: (data: any) => {
    //         console.log(data);
    //         this.ssoResponse = data;
    //         if (this.ssoResponse.registered == false) {
    //           this.router.navigate(['/registration'])
    //         } else {
    //           this.router.navigate(['/home'], { replaceUrl: true })
    //         }
    //       }
    //     })
    //   fetch('http://localhost:8080/api/auth/google', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ token: idToken })
    //   })
    //     .then(res => {
    //       if (!res.ok) {
    //         throw new Error('Network response was not ok');
    //       }
    //       return res.json();
    //     })
    //     .then(data => {
    //       const token = data?.token;
    //       const formData = {
    //         token: idToken,
    //         source: 'GOOGLE'
    //       }
    //       this.adminService.ssoLogin(formData)
    //         .subscribe({
    //           next: (data: any) => {
    //             console.log(data);
    //           }
    //         })
    //     })
    //     .catch(error => {
    //       console.error('There was a problem with the fetch operation:', error);
    //     })
    // }
    console.log("LoginComponent initialized");
    this.cdRef.detectChanges();

  }


  get f() {
    return this.loginForm.controls;
  }
  setLoginPrefrence() {
    this.isPhoneNumber = !this.isPhoneNumber;
    if (this.isPhoneNumber) {
      this.loginForm.get('phoneNumber')?.setValidators([Validators.required, Validators.pattern(/^\d{10}$/)]);
      this.loginForm.get('countryCode')?.setValidators([Validators.required]);
      this.loginForm.get('username')?.setValidators([]);
      this.loginForm.get('phoneNumber')?.updateValueAndValidity();
      this.loginForm.get('countryCode')?.updateValueAndValidity();
      this.loginForm.get('username')?.updateValueAndValidity();
    } else {
      this.loginForm.get('phoneNumber')?.setValidators([]);
      this.loginForm.get('countryCode')?.setValidators([]);
      this.loginForm.get('username')?.setValidators([Validators.required]);
      this.loginForm.get('phoneNumber')?.updateValueAndValidity();
      this.loginForm.get('countryCode')?.updateValueAndValidity();
      this.loginForm.get('username')?.updateValueAndValidity();
    }
  }

  onCountryChange(country: any) {
    if (country) {
      this.loginForm.patchValue({ countryCode: country.phonecode });
      this.countryCode = country.isoCode.toLowerCase();
      this.countryPhoneCode = country.phonecode;
    }
  }

  onSubmit() {
    this.submitted = true;
    const phoneNumber = this.loginForm.value.phoneNumber ? this.loginForm.value.phoneNumber.toString().replace(/\D+/g, '') : '';
    const countryCode = this.loginForm.value.countryCode || '';
    
    const submitForm = {
      username: this.isPhoneNumber ? phoneNumber: this.loginForm.value.username,
      password: this.loginForm.value.password
    }

    // console.log(submitForm);
    console.log(this.loginForm.valid)
    if (this.loginForm.valid) {
      this.loading = true;
      this.authService.login(submitForm, this.loginForm.value.rememberMe)
        .pipe(first())
        .subscribe({
          next: (data: any) => {
            this.loading = false;
            this.submitted = false;
            // this.profilePic$ = this.user.pipe(
            //   filter((user): user is User => user !== null && !!user.photoPath), 
            //   switchMap(user => this.getProfile(user.photoPath))
            // );
            this.router.navigate(['/home'], { replaceUrl: true });
          },
          error: error => {
            console.log(JSON.stringify(error));
            this.loading = false;
            
            // Extract error message from API response
            let errMsg = 'Invalid credentials. Please try again.'
            this.message = errMsg;
            // if (error.error && error.error.error) {
            //   errMsg = error.error.error;
            // } else if (error.error && typeof error.error === 'string') {
            //   errMsg = errMsg;
            // }
            
            // // Show only text inside inverted commas if present
            // if (typeof errMsg === 'string') {
            //   console.log("Message from api :", errMsg)
            //   this.message =errMsg
            // } else {
            //   this.message = errMsg;
            // }

            this.showError = true;
            this.submitted = false;
          }
        });
    }

  }

  clearServerError() {
    Object.keys(this.loginForm.controls).forEach((field) => {
      const control = this.loginForm.get(field);
      control?.valueChanges.subscribe(() => {
        this.showError = false;
        Object.keys(this.loginForm.controls).forEach((f) => {
          const c = this.loginForm.get(f);
          if (c) {
            const errors = { ...c.errors };
            if (errors && errors['serverError']) {
              delete errors['serverError'];
              c.setErrors(Object.keys(errors).length ? errors : null);
            }
          }
        });
      });
    });
  }

  landingPage() {
    this.router.navigate(['/']);
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  viewHelp() {
      const helpDialog = this.dialog.open(Help, {
        disableClose: true,
        height: '500px',
        width: '500px',
        panelClass: 'custom-dialog-container',
        hasBackdrop: true,
        autoFocus: false
  
      });
  
      helpDialog.afterClosed().subscribe({
  
      })
    }

  
}

